import { ROUTES } from "shared/constants";

export const isIframe = (route: string): boolean =>
  route === ROUTES.IFRAME || route === ROUTES.LOW_COST_SEARCH;

export const buildIframeRedirectUrl = (
  origin: string,
  pathname: string,
  query: Record<string, unknown>,
  googleLinkerParameter?: string | string[]
): string => {
  const googleLinkerParameterValue = Array.isArray(googleLinkerParameter)
    ? googleLinkerParameter[0]
    : googleLinkerParameter;
  const redirectQuery = {
    ...query,
    ...(googleLinkerParameterValue ? { _gl: googleLinkerParameterValue } : {}),
  };
  const search = Object.entries(redirectQuery)
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join("&");

  return `${origin}${pathname}?${search}`;
};
